import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { RemoteConfigActions } from './remote-config.actions';
import { RemoteConfigState } from './remote-config.state';

export const initRemoteConfigState: RemoteConfigState = {
  remoteConfig: {},
  loading: false,
  loaded: false,
  error: null,
};

export const remoteConfigReducer: ActionReducer<RemoteConfigState, Action> = createReducer(
  initRemoteConfigState,
  on(RemoteConfigActions.getRemoteConfig, (state): RemoteConfigState => ({ ...state })),

  on(
    RemoteConfigActions.getRemoteConfigSuccess,
    (state, { remoteConfig }): RemoteConfigState => ({
      ...state,
      remoteConfig,
      loading: false,
      loaded: true,
      error: null,
    })
  ),

  on(
    RemoteConfigActions.getRemoteConfigError,
    (state, { error }): RemoteConfigState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  ),

  on(
    RemoteConfigActions.closeBannerSuccess,
    (state, { banner }): RemoteConfigState => ({
      ...state,
      remoteConfig: {
        ...state.remoteConfig,
        [banner]: false,
      },
    })
  ),

  on(
    RemoteConfigActions.showBanner,
    (state, { isBannerHidden, banner }): RemoteConfigState => ({
      ...state,
      remoteConfig: {
        ...state.remoteConfig,
        [banner]: !isBannerHidden && state.remoteConfig[banner],
      },
    })
  )
);
